import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';

import {Observable, of} from 'rxjs';
import {catchError, tap} from 'rxjs/operators';

import {CoreCrmService} from '../core-crm.service';


@Injectable({providedIn: 'root'})
export class KYCService extends CoreCrmService {


  constructor(
    private http: HttpClient,
  ) {
    super(http, 'kyc');
  }

  getKYC(query?): Observable<any> {
    let params = new HttpParams();
    if (query != null) {
      Object.keys(query).forEach(val => {
        const value = query[val];
        if (value != null) { 
          params = params.append(val, value);
        }
      });
    }
    
    return this.http.get<any>(this.base_url, { params, headers: this.headers }).pipe(
      tap(_ => this.log(`getKYC`)),
      catchError(() => {
        this.log('getKYC failed, returning fallback data');
        return of([]);
      })
    );
  }

  
  getKYCType(): Observable<any> {
    const url = `${this.base_url}/type?tenantId=${localStorage.getItem('tenant')}`;
    return this.http.get<any>(url, {headers: this.headers}).pipe(
      tap(_ => this.log(`getKYCType`)),
      catchError(this.handleError<any>(`getKYCType`))
    );
  }

  getKYCStatus(): Observable<any> {
    const url = `${this.base_url}/status`;
    return this.http.get<any>(url, {headers: this.headers}).pipe(
      tap(_ => this.log(`getKYCStatus`)),
      catchError(this.handleError<any>(`getKYCStatus`))
    );
  }

  getKYCDocument(kycRequestDocumentId: number): Observable<any> {
    const url = `${this.base_url}/document?kycRequestDocumentId=${kycRequestDocumentId}`;
    return this.http.get(url, {headers: this.headers, responseType: 'blob'}).pipe(
      tap(_ => this.log(`getKYCDocument`)),
      catchError(this.handleError<any>(`getKYCDocument`, []))
    );
  }


  getKYCDocumentType(kycRequestTypeTenantId: number): Observable<any> {
    const url = `${this.base_url}/requireddocumenttypes?kycRequestTypeTenantId=${kycRequestTypeTenantId}`;
    return this.http.get<any>(url, {headers: this.headers}).pipe(
      tap(_ => this.log(`getKYCDocumentType`)),
      catchError(this.handleError<any>(`getKYCDocumentType`))
    );
  }

  approveRejectKYC(data: any): Observable<any> {
    const url = `${this.base_url}`;
    return this.http.post<any>(url, data, {headers: this.headers}).pipe(
      tap(_ => this.log(`approveRejectKYC`)),
      catchError(this.handleError<any>(`approveRejectKYC`))
    );
  }

  assignKyc(id: number) {
    const url = `${this.base_url}/${id}/assign`;
    return this.http.post<any>(url, {}).pipe( 
      tap(_ => this.log(`assignKyc for ID: ${id}`)),
      catchError(this.handleError<any>('assignKyc', 'error'))
    );
  }

  requestMoreInfo(id: number, comment) {
    const url = `${this.base_url}/${id}/requestMoreInformation`;
    return this.http.post<any>(url, {
      additionalComments: comment
    }).pipe( 
      tap(_ => this.log(`assignKyc for ID: ${id}`)),
      catchError(this.handleError<any>('assignKyc', 'error'))
    );
  }


  unassignKyc(id: number){
    const url = `${this.base_url}/${id}/unassign?force=1`;
    return this.http.post<any>(url, {headers: this.headers}).pipe(
      tap(_ => this.log(`unassignKyc`)),
      catchError(this.handleError<any>(`unassignKyc`, 'error'))
    );
  }
}
